/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import Modifier from './modifier';
import SubProduct from './sub-product';

export default forwardRefWithTranslation('product-editor')(
    class ModifierGroup extends React.Component {
        static propTypes = {
            modifier_group: PropTypes.object.isRequired,
            elRef: PropTypes.object,
            onHeadingClick: PropTypes.func.isRequired,
            onModifierClick: PropTypes.func.isRequired,
            onModifierQuantityChange: PropTypes.func.isRequired,
            onSubProductQuantityAdd: PropTypes.func.isRequired,
            onSubProductQuantityRemove: PropTypes.func.isRequired,
            onSubProductEdit: PropTypes.func.isRequired,
            t: PropTypes.func.isRequired,
        };

        static defaultProps = {
            elRef: null
        };

        render() {
            const {
                t,
                elRef,
                modifier_group,
                onHeadingClick,
                onModifierClick,
                onModifierQuantityChange,
                onSubProductQuantityAdd,
                onSubProductQuantityRemove,
                onSubProductEdit,
            } = this.props;
            if (
                modifier_group.visible === false ||
                modifier_group.is_restricted === true
            ) {
                return null;
            }
            let indicator_class_name = '';
            if (!modifier_group.selection_requirement_met) {
                indicator_class_name +=
                    'm2g-product-editor-modifier-group--selection-requirement-unmet ';
            }
            if (modifier_group.selection_limit_met) {
                indicator_class_name +=
                    'm2g-product-editor-modifier-group--selection-limit-met';
            }
            return (
                <div
                    data-modifier-group={modifier_group.id}
                    data-modifier-group-name={modifier_group.backend_name}
                    data-tags={modifier_group.tags.join(' ')}
                    data-selection-limit={modifier_group.selection_limit}
                    data-selection-requirement={
                        modifier_group.selection_requirement
                    }
                    data-is-collapsed={modifier_group.collapsed}
                    ref={elRef}
                    className={`m2g-product-editor-modifier-group ${indicator_class_name}`}
                >
                    <div
                        role="button"
                        tabIndex="0"
                        onKeyDown={() => {}}
                        onClick={() => onHeadingClick(modifier_group)}
                        className="m2g-product-editor-modifier-group-header"
                    >
                        <span className="m2g-product-editor-modifier-group-title m2g-subtitle-text">
                            {modifier_group.name}
                        </span>

                        {modifier_group.selection_limit > 0 &&
                            modifier_group.selection_requirement_met && (
                                <Trans
                                    i18nKey="product-editor:modifier_group_selection_limit"
                                    values={{
                                        selection_count:
                                            modifier_group.selection_count,
                                        selection_limit:
                                            modifier_group.selection_limit,
                                    }}
                                >
                                    <span
                                        data-limit-badge
                                        className="m2g-product-editor-modifier-group-limit-badge m2g-product-editor-modifier-group-badge m2g-badge"
                                    >
                                        <span
                                            data-modifier-group-selection-count
                                        >
                                            {'{modifier_group.selection_count}'}
                                        </span>
                                        &nbsp; of &nbsp;
                                        {'{modifier_group.selection_limit}'}
                                        &nbsp; max
                                    </span>
                                </Trans>
                            )}

                        {modifier_group.selection_requirement > 0 && (
                            <span
                                data-requirement-badge
                                className="m2g-product-editor-modifier-group-requirement-badge m2g-product-editor-modifier-group-badge m2g-badge"
                            >
                                {modifier_group.selection_requirement === 1 ? (
                                    t('required')
                                ) : (
                                    <Trans
                                        i18nKey="product-editor:modifier_group_selection_requirement"
                                        values={{
                                            selection_count:
                                                modifier_group.selection_count,
                                            selection_requirement:
                                                modifier_group.selection_requirement,
                                        }}
                                    >
                                        <span>
                                            <span
                                                data-modifier-group-selection-count
                                            >
                                                {
                                                    '{modifier_group.selection_count}'
                                                }
                                            </span>
                                            &nbsp; of &nbsp;
                                            {
                                                '{modifier_group.selection_requirement}'
                                            }
                                            &nbsp; required
                                        </span>
                                    </Trans>
                                )}
                            </span>
                        )}
                    </div>

                    {!modifier_group.collapsed &&
                        modifier_group.modifiers.map(modifier => (
                            <Modifier
                                onClick={onModifierClick}
                                onQuantityChange={onModifierQuantityChange}
                                modifier={modifier}
                                key={modifier.id}
                            />
                        ))}

                    <div className="m2g-product-editor-modifier-group-products-container m2g-menu-products">
                        {!modifier_group.collapsed &&
                            _.map(
                                modifier_group.sub_products,
                                ({ menu_product, quantity }) => (
                                    <SubProduct
                                        onSubProductQuantityAdd={
                                            onSubProductQuantityAdd
                                        }
                                        onSubProductQuantityRemove={
                                            onSubProductQuantityRemove
                                        }
                                        onSubProductEdit={onSubProductEdit}
                                        menu_product={menu_product}
                                        modifier_group={modifier_group}
                                        quantity={quantity}
                                        key={menu_product.id}
                                    />
                                )
                            )}
                    </div>

                    <div className="m2g-clearfix" />
                </div>
            );
        }
    }
);
